<template>
    <el-dialog class="dbman-dialog" title="收藏所选行" :model-value="modelValue"
        width="min(520px, 92vw)" append-to-body
        @update:model-value="$emit('update:modelValue', $event)">
        <el-form label-width="90px">
            <el-form-item label="名称">
                <el-input v-model="form.name" placeholder="请输入收藏名称" maxlength="100" />
            </el-form-item>
            <el-form-item label="执行语句">
                <div class="dbman-sql-view">{{ form.sql || '（未记录）' }}</div>
            </el-form-item>
            <el-form-item label="描述">
                <el-input type="textarea" :rows="3" v-model="form.description" maxlength="200"
                    placeholder="可选，便于以后查阅" />
            </el-form-item>
            <el-form-item label="共享">
                <div class="dbman-switch-row">
                    <el-switch v-model="form.isShare" />
                    <span class="dbman-tips">开启后，该连接团队成员均可查看</span>
                </div>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dbman-dialog__foot">
                <el-button @click="$emit('update:modelValue', false)">取 消</el-button>
                <el-button type="primary" :loading="saving" @click="submit">保 存</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../../utils/request.js';

export default {
    name: 'DbFavoriteFormDialog',
    props: {
        modelValue: { type: Boolean, default: false },
        seed: { type: Object, default: null }
    },
    emits: ['update:modelValue', 'saved'],
    data() {
        return {
            saving: false,
            form: {
                name: '',
                description: '',
                isShare: false,
                sql: '',
                sqlBlockId: '',
                columns: [],
                rows: []
            }
        };
    },
    watch: {
        modelValue(open) {
            if (open) this.applySeed();
        }
    },
    methods: {
        applySeed() {
            const s = this.seed || {};
            this.form = {
                name: s.name || '',
                description: s.description || '',
                isShare: !!s.isShare,
                sql: s.sql || '',
                sqlBlockId: s.sqlBlockId || '',
                columns: s.columns || [],
                rows: s.rows || []
            };
        },
        submit() {
            if (!this.form.name) {
                ElMessage({ message: '请填写名称', type: 'warning', duration: 2000 });
                return;
            }
            const rows = this.form.rows || [];
            this.saving = true;
            request({
                url: '/dbManRowFavorite/save',
                method: 'post',
                data: {
                    sqlBlockId: this.form.sqlBlockId,
                    favoriteName: this.form.name,
                    description: this.form.description,
                    sqlText: this.form.sql || '',
                    columns: this.form.columns || [],
                    rows,
                    isShare: this.form.isShare
                }
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({ message: '已收藏 ' + rows.length + ' 行', type: 'success', duration: 2000 });
                    this.$emit('update:modelValue', false);
                    this.$emit('saved', {
                        sqlBlockId: this.form.sqlBlockId,
                        name: this.seed && this.seed.blockName
                    });
                } else {
                    ElMessage({ message: res.msg || '收藏失败', type: 'error', duration: 3000 });
                }
            }).finally(() => {
                this.saving = false;
            });
        }
    }
};
</script>

<style>
@import './dialog.css';
</style>
